import { render, staticRenderFns } from "./SelectFeatureTemplate.vue?vue&type=template&id=08a1e51c&"
import script from "./SelectFeatureTemplate.vue?vue&type=script&lang=js&"
export * from "./SelectFeatureTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports